import React from 'react';

const fmtMoney = value =>
  Number(value || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });

const fmtDate = value =>
  value
    ? new Date(`${String(value).slice(0, 10)}T12:00:00`)
        .toLocaleDateString('pt-BR')
    : '—';

function statusInfo(item) {
  const mapa = {
    AGUARDANDO_VENCIMENTO: {
      label: 'Aguardando vencimento',
      color: '#D97706',
      bg: '#FEF3C7'
    },
    VENCE_HOJE: {
      label: 'Vence hoje',
      color: '#C2410C',
      bg: '#FFEDD5'
    },
    EM_ATRASO: {
      label: 'Em atraso',
      color: '#B91C1C',
      bg: '#FEE2E2'
    },
    QUITADO: {
      label: 'Quitado',
      color: '#15803D',
      bg: '#DCFCE7'
    },
    CANCELADO: {
      label: 'Cancelado',
      color: '#4B5563',
      bg: '#E5E7EB'
    }
  };

  return mapa[item.status_operacional] || {
    label: item.status || 'Pendente',
    color: '#4B5563',
    bg: '#E5E7EB'
  };
}

function ResumoCard({
  titulo,
  valor,
  detalhe,
  darkMode
}) {
  return (
    <div style={{
      background: darkMode ? '#1F2937' : '#FFFFFF',
      border: `1px solid ${darkMode ? '#374151' : '#E5E7EB'}`,
      borderRadius: 10,
      padding: '14px 16px',
      minWidth: 150,
      flex: '1 1 150px'
    }}>
      <div style={{
        fontSize: 12,
        color: darkMode ? '#9CA3AF' : '#6B7280'
      }}>
        {titulo}
      </div>

      <div style={{
        fontSize: 23,
        fontWeight: 800,
        marginTop: 5,
        color: darkMode ? '#F9FAFB' : '#111827'
      }}>
        {valor}
      </div>

      {detalhe && (
        <div style={{
          fontSize: 11,
          marginTop: 4,
          color: darkMode ? '#9CA3AF' : '#6B7280'
        }}>
          {detalhe}
        </div>
      )}
    </div>
  );
}

export default function PixFacilitadoView({
  darkMode,
  data,
  resumo,
  loading,
  filtro,
  setFiltro,
  onRefresh
}) {
  const txt = darkMode ? '#F9FAFB' : '#111827';
  const sub = darkMode ? '#9CA3AF' : '#6B7280';
  const bg = darkMode ? '#1F2937' : '#FFFFFF';
  const bdr = darkMode ? '#374151' : '#E5E7EB';

  const copiarPix = async codigo => {
    if (!codigo) {
      window.alert('O PIX da 2ª parcela ainda não foi gerado.');
      return;
    }

    try {
      await navigator.clipboard.writeText(codigo);
      window.alert('PIX copia e cola copiado.');
    } catch {
      window.prompt('Copie o PIX abaixo:', codigo);
    }
  };

  return (
    <div>
      <div style={{
        display: 'flex',
        gap: 10,
        flexWrap: 'wrap',
        marginBottom: 18
      }}>
        <ResumoCard
          titulo="Total de clientes"
          valor={resumo.total || 0}
          darkMode={darkMode}
        />

        <ResumoCard
          titulo="Em aberto"
          valor={resumo.em_aberto || 0}
          detalhe={fmtMoney(resumo.valor_em_aberto)}
          darkMode={darkMode}
        />

        <ResumoCard
          titulo="Vencem hoje"
          valor={resumo.vencem_hoje || 0}
          darkMode={darkMode}
        />

        <ResumoCard
          titulo="Em atraso"
          valor={resumo.atrasados || 0}
          darkMode={darkMode}
        />

        <ResumoCard
          titulo="Quitados"
          valor={resumo.quitados || 0}
          detalhe={fmtMoney(resumo.valor_quitado)}
          darkMode={darkMode}
        />

        <ResumoCard
          titulo="Atendimento humano"
          valor={resumo.atendimento_humano || 0}
          darkMode={darkMode}
        />
      </div>

      <div style={{
        display: 'flex',
        gap: 8,
        alignItems: 'center',
        flexWrap: 'wrap',
        marginBottom: 14
      }}>
        {[
          ['TODOS', 'Todos'],
          ['AGUARDANDO_VENCIMENTO', 'Aguardando'],
          ['VENCE_HOJE', 'Vence hoje'],
          ['EM_ATRASO', 'Em atraso'],
          ['QUITADO', 'Quitados']
        ].map(([id, label]) => (
          <button
            key={id}
            onClick={() => setFiltro(id)}
            style={{
              border: `1px solid ${bdr}`,
              borderRadius: 7,
              padding: '7px 11px',
              cursor: 'pointer',
              fontSize: 12,
              fontWeight: 700,
              background: filtro === id ? '#10B981' : bg,
              color: filtro === id ? '#FFFFFF' : txt
            }}
          >
            {label}
          </button>
        ))}

        <button
          onClick={onRefresh}
          style={{
            marginLeft: 'auto',
            border: 'none',
            borderRadius: 7,
            padding: '8px 13px',
            cursor: 'pointer',
            fontWeight: 700,
            background: '#3B82F6',
            color: '#FFFFFF'
          }}
        >
          ↻ Atualizar
        </button>
      </div>

      {loading ? (
        <div style={{
          padding: 40,
          textAlign: 'center',
          color: sub
        }}>
          Carregando cobranças…
        </div>
      ) : data.length === 0 ? (
        <div style={{
          background: bg,
          border: `1px solid ${bdr}`,
          borderRadius: 10,
          padding: 45,
          textAlign: 'center',
          color: sub
        }}>
          <div style={{ fontSize: 30, marginBottom: 10 }}>💳</div>
          Nenhum cliente no PIX Facilitado.
          <div style={{ fontSize: 12, marginTop: 6 }}>
            Os clientes aparecerão aqui após a confirmação da entrada.
          </div>
        </div>
      ) : (
        <div style={{
          overflowX: 'auto',
          background: bg,
          border: `1px solid ${bdr}`,
          borderRadius: 10
        }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            minWidth: 1050,
            color: txt
          }}>
            <thead>
              <tr>
                {[
                  'Cliente',
                  'CPF/CNPJ',
                  'Tipo',
                  '2ª parcela',
                  'Vencimento',
                  'Prazo',
                  'Status',
                  'PIX',
                  'Ações'
                ].map(coluna => (
                  <th key={coluna} style={{
                    textAlign: 'left',
                    padding: '12px 13px',
                    fontSize: 12,
                    color: sub,
                    borderBottom: `1px solid ${bdr}`
                  }}>
                    {coluna}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {data.map(item => {
                const status = statusInfo(item);
                const phone =
                  item.phone || item.whatsapp_number || '';

                let prazo = '—';

                if (item.status_operacional === 'QUITADO') {
                  prazo = 'Pago';
                } else if (item.status_operacional === 'EM_ATRASO') {
                  prazo = `${item.dias_atraso} dia(s)`;
                } else if (item.status_operacional === 'VENCE_HOJE') {
                  prazo = 'Hoje';
                } else {
                  prazo = `${item.dias_restantes} dia(s)`;
                }

                return (
                  <tr key={item.id}>
                    <td style={{
                      padding: 13,
                      borderBottom: `1px solid ${bdr}`
                    }}>
                      <div style={{ fontWeight: 700 }}>
                        {item.nome || 'Sem nome'}
                      </div>
                      <div style={{ fontSize: 11, color: sub }}>
                        {phone}
                      </div>
                    </td>

                    <td style={{
                      padding: 13,
                      fontSize: 12,
                      borderBottom: `1px solid ${bdr}`
                    }}>
                      {item.cpf_cnpj || '—'}
                    </td>

                    <td style={{
                      padding: 13,
                      fontSize: 12,
                      borderBottom: `1px solid ${bdr}`
                    }}>
                      {item.tipo_pessoa || 'PF'}
                    </td>

                    <td style={{
                      padding: 13,
                      fontWeight: 700,
                      borderBottom: `1px solid ${bdr}`
                    }}>
                      {fmtMoney(item.valor_parcela)}
                    </td>

                    <td style={{
                      padding: 13,
                      fontSize: 12,
                      borderBottom: `1px solid ${bdr}`
                    }}>
                      {fmtDate(item.data_vencimento)}
                    </td>

                    <td style={{
                      padding: 13,
                      fontSize: 12,
                      borderBottom: `1px solid ${bdr}`
                    }}>
                      {prazo}
                    </td>

                    <td style={{
                      padding: 13,
                      borderBottom: `1px solid ${bdr}`
                    }}>
                      <span style={{
                        display: 'inline-block',
                        padding: '5px 9px',
                        borderRadius: 15,
                        fontSize: 11,
                        fontWeight: 800,
                        color: status.color,
                        background: status.bg
                      }}>
                        {status.label}
                      </span>

                      {item.atendimento_humano_pendente && (
                        <div style={{
                          color: '#DC2626',
                          fontSize: 10,
                          fontWeight: 700,
                          marginTop: 5
                        }}>
                          ⚠ Atendimento necessário
                        </div>
                      )}
                    </td>

                    <td style={{
                      padding: 13,
                      fontSize: 12,
                      borderBottom: `1px solid ${bdr}`
                    }}>
                      {item.segunda_payment_id_mp
                        ? 'Gerado'
                        : 'Não gerado'}
                    </td>

                    <td style={{
                      padding: 13,
                      borderBottom: `1px solid ${bdr}`
                    }}>
                      <div style={{
                        display: 'flex',
                        gap: 5,
                        flexWrap: 'wrap'
                      }}>
                        <button
                          onClick={() => copiarPix(item.pix_copy_paste)}
                          style={{
                            border: 'none',
                            borderRadius: 6,
                            padding: '6px 9px',
                            cursor: 'pointer',
                            background: '#10B981',
                            color: '#FFFFFF',
                            fontSize: 11,
                            fontWeight: 700
                          }}
                        >
                          Copiar PIX
                        </button>

                        <a
                          href={`https://wa.me/${String(phone).replace(/\D/g, '')}`}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            borderRadius: 6,
                            padding: '6px 9px',
                            background: '#25D366',
                            color: '#FFFFFF',
                            fontSize: 11,
                            fontWeight: 700,
                            textDecoration: 'none'
                          }}
                        >
                          WhatsApp
                        </a>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
